import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImportObjectService {
  private readonly httpClient = inject(HttpClient);

  import(file: any) {
    const data = new FormData();
    for (const item of file) {
      data.append('files', item);
    }
    return this.httpClient.post('objects/import/', data);
  }

  getImportsList() {
    return this.httpClient.get('objects/import_task/');
  }

  getResultImport(taskId: string) {
    return this.httpClient.get(`objects/import_task/${taskId}/`);
  }

  deleteProcessImport(taskId: string) {
    return this.httpClient.delete(`objects/import_task/${taskId}/`);
  }
}
